import api from "./api";
import { SnapshotEmpreendimento, SnapshotUnidade, SnapshotEmpreendimentoQueryParams, SnapshotUnidadeQueryParams } from "../types/movimentacao";
import { PaginatedResponse } from "../types/empreendimento";

export const snapshotEmpreendimentoService = {
  list: async (params?: SnapshotEmpreendimentoQueryParams): Promise<PaginatedResponse<SnapshotEmpreendimento>> => {
    const response = await api.get("/api/snapshots/empreendimento/", { params });
    return response.data;
  },
  getById: async (id: number): Promise<SnapshotEmpreendimento> => {
    const response = await api.get(`/api/snapshots/empreendimento/${id}/`);
    return response.data;
  },
};

export const snapshotUnidadeService = {
  list: async (params?: SnapshotUnidadeQueryParams): Promise<PaginatedResponse<SnapshotUnidade>> => {
    const response = await api.get("/api/snapshots/unidade/", { params });
    return response.data;
  },
  getById: async (id: number): Promise<SnapshotUnidade> => {
    const response = await api.get(`/api/snapshots/unidade/${id}/`);
    return response.data;
  },
};
